var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { Button, Icon } from '@patternfly/react-core';
import { TagIcon } from '@patternfly/react-icons';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    buttonTagCount: {
        color: 'var(--pf-v5-global--icon--Color--light)',
        display: 'flex',
        alignItems: 'center'
    },
    tagText: {
        marginLeft: 10
    }
});
const TagCount = (_a) => {
    var { count, className, iconSize = 'md' } = _a, props = __rest(_a, ["count", "className", "iconSize"]);
    const classes = useStyles();
    const tagClasses = clsx(classes.buttonTagCount, className);
    return (React.createElement(Button, Object.assign({ "aria-label": "Tag count" }, props, { variant: "plain", isDisabled: !count, className: tagClasses }),
        React.createElement(Icon, { iconSize: iconSize },
            React.createElement(TagIcon, null)),
        React.createElement("span", { className: classes.tagText }, count)));
};
export default TagCount;
